<template>
  <div pageC>
    <div class="cover">
      <transition name="fade">
        <div class="mov" v-if="step === 1">
          <article class="box" v-if="env === 'pc'">
            <p class="mask"></p>
            <iframe src="https://www.youtube.com/embed/0ylaSkrgGWE?rel=0&amp;amp;autoplay=1&amp;amp;controls=0&amp;amp;loop=0&amp;amp;showinfo=1&amp;amp;modestbranding=0&amp;amp;disablekb=1&amp;amp;enablejsapi=0" width="100%" height="100%" frameborder="0" allow="autoplay;fullscreen" allowfullscreen=""></iframe>
          </article>
          <article v-else>
            <a class="btn-play" @click="setMovOn"></a>
          </article>
        </div>
        <ul class="cont" v-else>
          <li class="c1" :class="{on:activeId === 1}" @mouseleave="activeId=0" v-if="env === 'pc' || (env === 'mob' && step === 2)">
            <a class="btn-tab" v-if="env==='mob'" @click="setChangeStep(3)"></a>
            <p class="symbol" @click="activeId = 1">
            <span>
              <!--<em>여기 남겨진 자들이 있는 한, <br class="m-ent"/>우린 결단코 싸워가겠다.</em><br/><br/>-->
              <!--조화의 수호룡 아르세룬의 유지를 잇는 <br class="m-ent"/>수호의 방패 연맹. 수장은 아칸드이다.<br/><br class="m-ent"/>-->
              <!--신이 떠난 이후 도래한 파멸을 막기 위해 <br class="m-ent"/>신의 남은 권능을 이용해 <br class="m-ent"/>거대한 수호 결계를 세우고 침략자들을 처단한다. <br/><br class="m-ent"/>-->
              <!--남겨진 자들을 지키려는 그들은 나르를 수호하고<br class="m-ent"/> 파멸을 막아내<br class="p-ent"/>-->
              <!--그 누구도 침범치 못할 성역을 <br class="m-ent"/>만들고자 싸워나간다.-->
            </span>
            </p>
          </li>
          <li class="c2" :class="{on:activeId === 2}" @mouseleave="activeId=0" v-if="env === 'pc' || (env === 'mob' && step === 3)">
            <a class="btn-tab" v-if="env==='mob'" @click="setChangeStep(2)"></a>
            <p class="symbol" @click="activeId = 2">
             <span>
              <!--<em>우리 남은 모든 것을 불태워, 나아가겠다.</em><br/><br/>-->
              <!--혼돈의 수호룡 베제니엘의 유지를 잇는<br class="m-ent"/> 심판의 불꽃 연맹. 수장은 벨자브이다.<br/><br class="m-ent"/>-->
              <!--신에게 버림 받은 이후 파멸을 막기 위해 <br class="m-ent"/>신이 남긴 지식을 이용하여 <br class="m-ent"/>거대한 탑을 세우고 힘을 축적하기 시작한다.<br/><br class="m-ent"/>-->
              <!--더 이상 남은 것이 없어 스스로를 태우는 <br class="m-ent"/>불꽃에 사로 잡힌 그들은<br/>-->
              <!--차원 너머를 꿰뚫는 절대 무적의 힘을 얻고자 한다.-->
            </span>
            </p>
          </li>
        </ul>
      </transition>
      <ul class="page-bts">
        <li><a @click="goNext(false)"></a></li>
        <li><a @click="goNext(true)"></a></li>
      </ul>
    </div>
    <article class="tab-bts" v-if="env === 'pc'">
      <ul>
        <li :class="{on:step===1}"><a @click="setChangeStep(1)"></a></li>
        <li :class="{on:step===2}"><a @click="setChangeStep(2)"></a></li>
      </ul>
    </article>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'pageC',
  data() {
    return {
      step: 1,
      activeId: 0,
      win: null,
      mov: null,
      limit: 2,
    };
  },
  watch: {
    $route() {
      this.reset();
    },
  },
  computed: {
    env() {
      return this.$store.state.environment;
    },
  },
  methods: {
    setMovOn() {
      this.$store.commit('onMov', 'https://www.youtube.com/embed/0ylaSkrgGWE');
    },
    reset() {
      if (this.$route.name === 'world' && this.$route.query.reset === 'Y') {
        let c = Number(this.$route.query.code) || this.step;
        c = c > this.limit ? this.limit : c < 0 ? 0 : c;
        this.setChangeStep(c);
      }
    },
    setChangeStep(id) {
      this.step = id;
      if (this.$route.name === 'world' && this.env === 'mob') {
        this.$router.replace(`world?code=${Math.min(this.step, 3)}&reset=Y`);
      }

      if (this.step === 0 && this.env === 'pc') {
        setTimeout(() => {
          this.mov = $('.mov .box');
          this.resize();
        }, 60);
      }
    },
    goNext(next) {
      let step = this.step + (next ? 1 : -1);
      step = next && step > this.limit ? 1 : !next && step < 1 ? this.limit : step;
      this.setChangeStep((step % (this.limit + 1)));
    },
    resize() {
      if (this.step === 1 && this.env === 'pc') {
        const w = Math.max(this.win.width(), this.win.height() * 2);
        const h = this.win.height();

        this.mov.width(w);
        this.mov.height(w);
        this.mov.css('top', `${-((w - h) / 2)}px`).css('left', `${(this.win.width() - w) / 2}px`);
      }
    },
  },
  mounted() {
    this.limit = this.env === 'pc' ? 2 : 3;
    this.win = $(window);
    this.mov = $('.mov .box');
    this.win.resize(this.resize);
    this.resize();
    this.reset();
  },
};
</script>

<style lang="less">
  @import '../less/proj';
  .mob{
    [pageC]{ .rel;
      .cover{
        .mov{.wh(100% ,1700);  .contain("@{mob}/p3/bg.png");
          .btn-play{.block; .contain("@{mob}/btn-play.png"); .wh(154); .abs; .t(385); .l(50%); .ml(-77);}
        }
        .cont{ .wh(100% ,1420);
          li{.abs; .block; .wh(100%);
            .btn-tab{ .wh(345,45); .abs; .t(142);}
            &.c1{ .cover("@{mob}/p3/bg1.jpg");
              .btn-tab{.contain("@{mob}/p3/btn-tab1.png"); .r(-140);}
              .symbol{.contain("@{mob}/p3/symbol1.png");
                span{.contain("@{mob}/p3/desc1.png");}
              }
            }

            &.c2{ .cover("@{mob}/p3/bg2.jpg");
              .btn-tab{.contain("@{mob}/p3/btn-tab2.png"); .l(-140);}
              .symbol{.contain("@{mob}/p3/symbol2.png");
                span{.contain("@{mob}/p3/desc2.png");}
              }
            }

            .symbol{ .wh(100%,219); .abs; .bg-sx(186); .bg-x(50%); .tc; .t(500);
             /* span{ color:white; .fs(24); .mt(284); .ib; .regular; .ls(-.5);
                em{.bold; color:#ffd2a6; .fs(28);}
              }*/
              span{.ib; .wh(520,447); .abs; .ml(-260); .t(280); .l(50%); }
            }
          }
        }
      }
    }
    .page-bts{.t(710);}
  }

  .pc{
    [pageC]{ .wh(100%); .fix;
      .cover{ .wh(100%);
        .mov{.wh(100%); .min-w(1100px);
          .box{.wh(100%); .fix;
            .mask{.abs; .wh(100%);}
          }
        }
        .cont{.ib-list; .wh(100%);
          &:before{.cnt; .contain("@{pc}/p3/union.png"); .wh(531px,44px); .fix; .l(50%); .t(50%); z-index: 2; .ml(-270px);}
          li{.fix; .wh(70%,100%); transform: skew(-15deg); transition: width .5s,opacity .5s; overflow: hidden; .-box; will-change: transform;
            &:before{.cnt; .abs; .bg-y(50%); .t(0); .min-w(1100px); .wh(150%,100%); transform: scale(1) skew(15deg); will-change: transform;}
            &:nth-of-type(1){.l(-20%); .pl(20%);
              &:before{left:0; .cover("@{pc}/p3/bg1.png");}
              .symbol{.contain("@{pc}/p3/symbol1.png");  .r(350px);
                span{.contain("@{pc}/p3/desc1.png");}
              }
            }
            &:nth-of-type(2){.r(-20%); .pr(20%);
              &:before{right:0; .cover("@{pc}/p3/bg2.png"); .bg-x(100%);}
              .symbol{.contain("@{pc}/p3/symbol2.png"); .l(350px);
                span{.contain("@{pc}/p3/desc2.png");}
              }
            }
            .symbol{ .wh(144px,209px); .abs; transform: skew(15deg); .t(50%); .mt(-100px); .pointer;
           /*   span{.ib; .w(800px);  .ml(-400px); .fs(18px); .lh(28px);  .tc; color:white; .abs; .t(240px); .l(50%); opacity: 0; display: none; .ls(-.5);
                em{.bold; color:#ffd2a6; .fs(24px);}
              }*/
              span{.ib; .wh(863px,224px); .abs; .ml(-432px); .t(240px); .l(50%); opacity: 0; display: none; transition: 1s; }
            }
            &.on{z-index: 3; .w(90%);
              &:before{.bg-y(-50px);}
              .symbol{.l(50%); .mt(-200px);
                span{opacity: 1; .ib;}
              }
              &:nth-of-type(1){
                .symbol{.mr(-300px);}
              }
              &:nth-of-type(2){
                .symbol{.ml(-300px);}
              }
            }
          }
        }
      }
      .tab-bts{
        ul{ .ml(-425px);
          li{
            a{.block;.wh(100%);}
            &:nth-of-type(1){.contain("@{pc}/p3/btn-tab1.png"); .wh(263px,100%); .l(0);
              &.on, &:hover{.contain("@{pc}/p3/btn-tab1-on.png");}
            }
            &:nth-of-type(2){.contain("@{pc}/p3/btn-tab2.png"); .wh(263px,100%); .l(247px);
              &.on, &:hover{.contain("@{pc}/p3/btn-tab2-on.png");}
            }
          }
        }
      }
      @media screen and (max-width: @screen-xxl-min){
        .tab-bts{
          ul{.ml(-318px);
            li{
              &:nth-of-type(1){.wh(175px,100%);}
              &:nth-of-type(2){.wh(175px,100%); .l(170px);}
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pageC.vue